module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "shopping-cart-img"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mobile-container"
  }, [_c('div', {
    staticClass: "col-main"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31a75c27!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/cms/Page.vue
// module id = 238
// module chunks = 1